enum RenderOrientations {
    Horizontal = "horz",
    Vertical = "vert",
    LeftRight = "leftright",
    RightLeft = "rightleft"
}

export default RenderOrientations;

export type RenderOrientation = RenderOrientations.Horizontal | RenderOrientations.Vertical;
export type RenderOrientationFlow = RenderOrientations.LeftRight | RenderOrientations.RightLeft;